import classes from './Pill.module.css';

import {
	capitalizeString,
	truncateString,
} from '@utils/functions';
import {
	Pill as NativePill,
	Tooltip,
} from '@mantine/core';

export const Pill = (props: {
	color?: string;
	text: string;
}) => {
	return (
		<NativePill
			classNames={{
				root: classes.pill,
			}}
			styles={{
				root: {
					backgroundColor: '--mantine-color-grey-clair',
				},
			}}
		>
			<Tooltip
				disabled={props.text.length <= 15}
				label={capitalizeString(props.text)}
			>
				<span
					{...(props?.color && {
						style: {
							color: props?.color,
						},
					})}
				>
					{'● '}
					<span className={classes.labelText}>
						{truncateString(
							capitalizeString(props.text),
							15
						)}
					</span>
				</span>
			</Tooltip>
		</NativePill>
	);
};
